import { VoltApiError } from "../voltApi";

// Parameters the MCP callback appends to /#/profile; all of them leave the URL before any request.
const RETURN_PARAMS = ["google", "code", "state"] as const;

export type GoogleReturn =
  | { kind: "confirm"; code: string; state: string }
  | { kind: "error" };

/** What the MCP callback sent back: code and state to confirm with the own login, or a failed consent. */
export const readGoogleReturn = (search: string): GoogleReturn | null => {
  const params = new URLSearchParams(search);
  const google = params.get("google");
  if (google === "error") return { kind: "error" };
  if (google !== "confirm") return null;
  const code = params.get("code");
  const state = params.get("state");
  return code && state ? { kind: "confirm", code, state } : { kind: "error" };
};

/** The search string without the callback parameters, other parameters kept. */
export const stripGoogleReturn = (search: string): string => {
  const params = new URLSearchParams(search);
  RETURN_PARAMS.forEach((p) => params.delete(p));
  const rest = params.toString();
  return rest ? `?${rest}` : "";
};

/** Message key for a failed confirm: 403 = link started by another account, 400 = expired or invalid. */
export const confirmErrorKey = (error: unknown): string => {
  const status = error instanceof VoltApiError ? error.status : 0;
  if (status === 403) return "crm.profile.google.result_foreign";
  if (status === 400) return "crm.profile.google.result_expired";
  return "crm.profile.google.result_error";
};
